import Error from './index.vue'

export default Error
